import React, {useEffect, useState} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import moment from "moment";
import {t, useLocale} from "../../../shared-services/translate";
import {Link} from "react-router-dom";

const CartSidebarNextDelivery = (props) => {
  const {className = "", style} = props;
  const {deliveryTerms} = useSelector(state => state.session);
  const locale = useLocale();

  const [nextDeliveryDate, setDeliveryDate] = useState(null);

  useEffect(() => {
    if (deliveryTerms?.nearest_slot?.regular?.slot?.delivery_time) {
      const momentLocale = moment();
      momentLocale.locale(locale);

      const time = deliveryTerms.nearest_slot.regular.slot.delivery_time;

      const timeOptions = {
        month: "short",
        day: "numeric"
      };
      const timeLabel = new Date(time).toLocaleDateString(locale, timeOptions);

      setDeliveryDate(timeLabel);
    }
  }, [deliveryTerms]);

  return nextDeliveryDate && <div
    className="font-size-body-smaller text-align-left"
    style={{

    }}
  >
    <div
      className={`
        flex
        gap-10
        align-items-center
        justify-content-center
        padding-5
        border-radius-sm
        border-color-light
        border-default
        ${className}
      `}
      style={style}
    >
      <img
        alt="no saturday delivery"
        src="/resources/farmy/images/icons/quick_delivery_truck_green.svg"
        loading="lazy"
        style={{
          height: "30px"
        }}
      />

      <p className="line-height-short margin-bottom-0 font-weight-600">
        {t("info_header.closest_delivery_time")}
        &nbsp;{nextDeliveryDate}

        <br/>

        <Link
          className="text-color-light-blue text-decoration-underline"
          to={t("shipping_costs.delivery_cost_details_page.link")}
        >
          {t("delivery_details")}
        </Link>
      </p>
    </div>
  </div>;
};

export default CartSidebarNextDelivery;
